import * as z from "zod";
//#region src/__generated__/filesystem-gge/directories/zod/directoryCreateDtoSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const directoryCreateDtoSchema = z.object({
	baseName: z.string(),
	parentId: z.uuid(),
	sourceId: z.uuid(),
	sourceType: z.enum([
		"PROJECT_ID",
		"WORK_GROUP",
		"MODEL_REPOSITORY",
		"CONTRACTOR_MANAGEMENT",
		"COSMOS",
		"COSMOS_FOR_DELETE",
		"COSMOS_FOR_MIGRATE",
		"ONTOLOGY_FILE_UPLOAD",
		"CLASSIFIER_TABLE_ROW",
		"ONTOLOGY_CLASSIFIER_TABLE",
		"ONTOLOGY_CATALOG_DEFINITION",
		"ONTOLOGY_SFO_DEFINITION",
		"MODEL_PROPERTIES",
		"KNOWLEDGE_BASE",
		"REPORT_GENERATION_CACHE"
	])
}).describe("Модель для создания папки.");
//#endregion
//#region src/__generated__/filesystem-gge/directories/zod/fileMetaDtoSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const fileMetaDtoSchema = z.object({
	author: z.uuid(),
	baseName: z.string(),
	createdAt: z.union([z.number(), z.iso.datetime()]),
	ext: z.string().nullish(),
	id: z.uuid(),
	isDeleted: z.boolean(),
	modifiedAt: z.union([z.number(), z.iso.datetime()]),
	parentId: z.uuid().nullish(),
	preview: z.string().nullish().describe("Файл preview закодированный в base64. Поле может быть null, если для данного элемента не поддерживаются preview либо, если для данного элемента preview еще не было получено/сконвертировано."),
	previewId: z.uuid().nullish(),
	size: z.int(),
	sourceId: z.uuid(),
	sourceType: z.enum([
		"PROJECT_ID",
		"WORK_GROUP",
		"MODEL_REPOSITORY",
		"CONTRACTOR_MANAGEMENT",
		"COSMOS",
		"COSMOS_FOR_DELETE",
		"COSMOS_FOR_MIGRATE",
		"ONTOLOGY_FILE_UPLOAD",
		"CLASSIFIER_TABLE_ROW",
		"ONTOLOGY_CLASSIFIER_TABLE",
		"ONTOLOGY_CATALOG_DEFINITION",
		"ONTOLOGY_SFO_DEFINITION",
		"MODEL_PROPERTIES",
		"KNOWLEDGE_BASE",
		"REPORT_GENERATION_CACHE"
	]),
	type: z.enum([
		"DIRECTORY",
		"DOCUMENT",
		"CLASSIFIER_DOCUMENT",
		"MODEL",
		"MODEL_DATA",
		"MODEL_DATA_SIMPLIFIED",
		"IMAGE",
		"COMMENT_DOCUMENT",
		"COSMOS_DOCUMENT",
		"COSMOS_GEOSERVER_DOCUMENT",
		"BUILDING_MANAGEMENT_DOCUMENT",
		"TASK_TRACKER",
		"MODEL_REPOSITORY",
		"CONTRACTOR_MANAGEMENT",
		"ONTOLOGY_DOCUMENT",
		"COLLISION_DOCUMENT",
		"KNOWLEDGE_BASE_DOCUMENT",
		"REPORT_GENERATION_CACHE",
		"PDF_DOCUMENT",
		"PDF_DOCUMENT_PREVIEW"
	]),
	version: z.int(),
	versionParentId: z.uuid().nullish().describe("Id первой версии этого файла. Присутствует только если поле version > 1")
});
//#endregion
//#region src/__generated__/filesystem-gge/directories/zod/create3Schema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const create3Status200Schema = fileMetaDtoSchema;
const create3ResponseSchema = create3Status200Schema;
const create3DataSchema = directoryCreateDtoSchema.describe("Модель для создания папки.");
//#endregion
//#region src/__generated__/filesystem-gge/directories/zod/directoryCreateTemplateDtoSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const directoryCreateTemplateDtoSchema = z.object({
	sourceId: z.uuid(),
	sourceType: z.enum([
		"PROJECT_ID",
		"WORK_GROUP",
		"MODEL_REPOSITORY",
		"CONTRACTOR_MANAGEMENT",
		"COSMOS",
		"COSMOS_FOR_DELETE",
		"COSMOS_FOR_MIGRATE",
		"ONTOLOGY_FILE_UPLOAD",
		"CLASSIFIER_TABLE_ROW",
		"ONTOLOGY_CLASSIFIER_TABLE",
		"ONTOLOGY_CATALOG_DEFINITION",
		"ONTOLOGY_SFO_DEFINITION",
		"MODEL_PROPERTIES",
		"KNOWLEDGE_BASE",
		"REPORT_GENERATION_CACHE"
	]),
	type: z.enum([
		"LINEAR",
		"PLANAR",
		"SIMPLE"
	])
}).describe("Модель для создания шаблона папок проекта.");
//#endregion
//#region src/__generated__/filesystem-gge/directories/zod/createFromTemplateSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const createFromTemplateStatus200Schema = z.array(fileMetaDtoSchema);
const createFromTemplateResponseSchema = createFromTemplateStatus200Schema;
const createFromTemplateDataSchema = directoryCreateTemplateDtoSchema.describe("Модель для создания шаблона папок проекта.");
//#endregion
//#region src/__generated__/filesystem-gge/directories/zod/directoryDeleteResponseSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const directoryDeleteResponseSchema = z.object({ filename: z.string().nullish() });
//#endregion
//#region src/__generated__/filesystem-gge/directories/zod/delete8Schema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const delete8PathIdSchema = z.uuid();
const delete8Status200Schema = z.array(directoryDeleteResponseSchema);
const delete8ResponseSchema = delete8Status200Schema;
//#endregion
//#region src/__generated__/filesystem-gge/directories/zod/documentsCountResponseSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const documentsCountResponseSchema = z.object({ count: z.int().nullish() });
//#endregion
//#region src/__generated__/filesystem-gge/directories/zod/fileMetaChildDtoSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const fileMetaChildDtoSchema = z.object({
	baseName: z.string(),
	createdAt: z.union([z.number(), z.iso.datetime()]),
	id: z.uuid(),
	modifiedAt: z.union([z.number(), z.iso.datetime()])
});
//#endregion
//#region src/__generated__/filesystem-gge/directories/zod/getBuildingManagementDocumentSectionFileMetaSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const getBuildingManagementDocumentSectionFileMetaPathIdSchema = z.uuid();
const getBuildingManagementDocumentSectionFileMetaStatus200Schema = fileMetaChildDtoSchema;
const getBuildingManagementDocumentSectionFileMetaResponseSchema = getBuildingManagementDocumentSectionFileMetaStatus200Schema;
//#endregion
//#region src/__generated__/filesystem-gge/directories/zod/getCommentSectionFileMetaSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const getCommentSectionFileMetaPathIdSchema = z.uuid();
const getCommentSectionFileMetaStatus200Schema = fileMetaChildDtoSchema;
const getCommentSectionFileMetaResponseSchema = getCommentSectionFileMetaStatus200Schema;
//#endregion
//#region src/__generated__/filesystem-gge/directories/zod/getModelSectionFileMetaSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const getModelSectionFileMetaPathIdSchema = z.uuid();
const getModelSectionFileMetaStatus200Schema = fileMetaChildDtoSchema;
const getModelSectionFileMetaResponseSchema = getModelSectionFileMetaStatus200Schema;
//#endregion
//#region src/__generated__/filesystem-gge/directories/zod/getRootSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const getRootPathIdSchema = z.uuid();
const getRootStatus200Schema = fileMetaDtoSchema;
const getRootResponseSchema = getRootStatus200Schema;
//#endregion
//#region src/__generated__/filesystem-gge/directories/zod/getSizeByDirectoryIdsRequestSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const getSizeByDirectoryIdsRequestSchema = z.object({ ids: z.array(z.uuid()).refine((items) => new Set(items).size === items.length, { message: "Array entries must be unique" }) });
//#endregion
//#region src/__generated__/filesystem-gge/directories/zod/getSizeByDirectoryIdsSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const getSizeByDirectoryIdsStatus200Schema = z.object({}).catchall(z.int());
const getSizeByDirectoryIdsResponseSchema = getSizeByDirectoryIdsStatus200Schema;
const getSizeByDirectoryIdsDataSchema = getSizeByDirectoryIdsRequestSchema;
//#endregion
//#region src/__generated__/filesystem-gge/directories/zod/getSizeByProjectIdSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const getSizeByProjectIdPathProjectIdSchema = z.uuid();
const getSizeByProjectIdStatus200Schema = z.int();
const getSizeByProjectIdResponseSchema = getSizeByProjectIdStatus200Schema;
//#endregion
//#region src/__generated__/filesystem-gge/directories/zod/directoryListResponseSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const directoryListResponseSchema = z.object({ fileMeta: z.union([fileMetaDtoSchema, z.null()]).optional() });
//#endregion
//#region src/__generated__/filesystem-gge/directories/zod/list8Schema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const list8PathIdSchema = z.uuid();
const list8Status200Schema = z.array(directoryListResponseSchema);
const list8ResponseSchema = list8Status200Schema;
//#endregion
//#region src/__generated__/filesystem-gge/directories/zod/listRootSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const listRootPathIdSchema = z.uuid();
const listRootStatus200Schema = z.array(directoryListResponseSchema);
const listRootResponseSchema = listRootStatus200Schema;
//#endregion
//#region src/__generated__/filesystem-gge/directories/zod/listRootTabSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const listRootTabPathIdSchema = z.uuid();
const listRootTabPathDirectoryTabSchema = z.enum(["IFC", "PDF"]);
const listRootTabStatus200Schema = z.array(directoryListResponseSchema);
const listRootTabResponseSchema = listRootTabStatus200Schema;
//#endregion
//#region src/__generated__/filesystem-gge/directories/zod/directoryMoveResponseSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const directoryMoveResponseSchema = z.object({ moveCnt: z.int().nullish() });
//#endregion
//#region src/__generated__/filesystem-gge/directories/zod/fileMoveDtoSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const fileMoveDtoSchema = z.object({
	id: z.uuid(),
	parentId: z.uuid()
}).describe("Move модель для файла.");
//#endregion
//#region src/__generated__/filesystem-gge/directories/zod/move6Schema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const move6Status200Schema = z.array(directoryMoveResponseSchema);
const move6ResponseSchema = move6Status200Schema;
const move6DataSchema = fileMoveDtoSchema.describe("Move модель для файла.");
//#endregion
//#region src/__generated__/filesystem-gge/directories/zod/directoryRenameResponseSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const directoryRenameResponseSchema = z.object({ fileMeta: z.union([fileMetaDtoSchema, z.null()]).optional() });
//#endregion
//#region src/__generated__/filesystem-gge/directories/zod/fileRenameDtoSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const fileRenameDtoSchema = z.object({
	id: z.uuid(),
	newName: z.string()
}).describe("Rename модель для файла.");
//#endregion
//#region src/__generated__/filesystem-gge/directories/zod/rename8Schema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const rename8Status200Schema = directoryRenameResponseSchema;
const rename8ResponseSchema = rename8Status200Schema;
const rename8DataSchema = fileRenameDtoSchema.describe("Rename модель для файла.");
//#endregion
//#region src/__generated__/filesystem-gge/directories/zod/revisionsCountResponseSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const revisionsCountResponseSchema = z.object({ count: z.int().nullish() });
//#endregion
//#region src/__generated__/filesystem-gge/directories/zod/revisionsGroupByIdResponseSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const revisionsGroupByIdResponseSchema = z.object({ revisionsGroupById: z.object({}).catchall(z.int()).nullish() });
//#endregion
export { create3DataSchema as $, getSizeByDirectoryIdsRequestSchema as A, getBuildingManagementDocumentSectionFileMetaPathIdSchema as B, directoryListResponseSchema as C, getSizeByDirectoryIdsDataSchema as D, getSizeByProjectIdStatus200Schema as E, getModelSectionFileMetaResponseSchema as F, delete8PathIdSchema as G, getBuildingManagementDocumentSectionFileMetaStatus200Schema as H, getModelSectionFileMetaStatus200Schema as I, directoryDeleteResponseSchema as J, delete8ResponseSchema as K, getCommentSectionFileMetaPathIdSchema as L, getRootResponseSchema as M, getRootStatus200Schema as N, getSizeByDirectoryIdsResponseSchema as O, getModelSectionFileMetaPathIdSchema as P, directoryCreateTemplateDtoSchema as Q, getCommentSectionFileMetaResponseSchema as R, list8Status200Schema as S, getSizeByProjectIdResponseSchema as T, fileMetaChildDtoSchema as U, getBuildingManagementDocumentSectionFileMetaResponseSchema as V, documentsCountResponseSchema as W, createFromTemplateResponseSchema as X, createFromTemplateDataSchema as Y, createFromTemplateStatus200Schema as Z, listRootPathIdSchema as _, rename8Status200Schema as a, list8PathIdSchema as b, move6DataSchema as c, fileMoveDtoSchema as d, create3ResponseSchema as et, directoryMoveResponseSchema as f, listRootTabStatus200Schema as g, listRootTabResponseSchema as h, rename8ResponseSchema as i, getRootPathIdSchema as j, getSizeByDirectoryIdsStatus200Schema as k, move6ResponseSchema as l, listRootTabPathIdSchema as m, revisionsCountResponseSchema as n, fileMetaDtoSchema as nt, fileRenameDtoSchema as o, listRootTabPathDirectoryTabSchema as p, delete8Status200Schema as q, rename8DataSchema as r, directoryCreateDtoSchema as rt, directoryRenameResponseSchema as s, revisionsGroupByIdResponseSchema as t, create3Status200Schema as tt, move6Status200Schema as u, listRootResponseSchema as v, getSizeByProjectIdPathProjectIdSchema as w, list8ResponseSchema as x, listRootStatus200Schema as y, getCommentSectionFileMetaStatus200Schema as z };

//# sourceMappingURL=revisionsGroupByIdResponseSchema2.js.map